import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {AuthService} from '../../../../common/services/auth.service';
import {MatDialog} from '@angular/material';
import {Utils} from '../../../../common/services/Utils';
import {TranslateService} from '@ngx-translate/core';
import {ActivatedRoute} from '@angular/router';
import {RestorePasswordService} from '../../services/restore-password.service';
import {Response} from '../../../../common/dtos/response';
import {RestorePassword} from './restore-password';
import {User} from '../../../../common/models/user';
import {Enroll} from '../../../../common/models/enroll';
import {CommonService} from '../../../shared/services/common.service';

@Component({
  selector: 'app-login',
  templateUrl: './restore-password.component.html',
  styleUrls: ['./restore-password.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class RestorePasswordComponent implements OnInit {

  restorePass: RestorePassword;
  hashId: any;
  passwordMinLength: number;
  showPassword = false;
  showPasswordRepeat = false;

  constructor(
    private dialog: MatDialog,
    private utils: Utils,
    private route: ActivatedRoute,
    private translateService: TranslateService,
    private restorePasswordService: RestorePasswordService,
    private _authService: AuthService,
    private commonService: CommonService) {
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.hashId = params['id'];
    });
    this.restorePass = new RestorePassword();
    this.restorePass.hashId = this.hashId;
    if (this.hashId) {
      this.getData();
    }
    this.commonService.getPasswordMinLength().subscribe(data => {
      this.passwordMinLength = data;
    });
  }

  getData() {
    this.restorePasswordService.getHashData(this.hashId).subscribe(
      (res: Response) => {
        if (res.status === 'ERROR') {
          this.utils.notifyError(this.translateService.instant('restore_password.' + res.description), null);
        }
      },
      error => {
        this.utils.notifyError(this.translateService.instant('err_try_again_later'), null);
      }
    );
  }

  onSubmit() {
    this.restorePasswordService.changePassword(this.restorePass).subscribe(
      (res: Response) => {
        if (res.status === 'SUCCESS') {
          this._authService.getEnrollInfo(res.description).subscribe(data => {
            if (data) {
              const enroll = new Enroll(0, res.description, this.restorePass.password);
              this._authService.loginEnroll(enroll);
            } else {
              const user = new User(res.description, this.restorePass.password);
              this._authService.login(user);
            }
          }, error => {
            console.log('this._authService.getEnrollInfo() error:', error);
            const user = new User(res.description, this.restorePass.password);
            this._authService.login(user);
          });
        } else if (res.description) {
          this.utils.notifyError(this.translateService.instant('restore_password.' + res.description), null);
        }
      },
      error => {
        this.utils.notifyError(this.translateService.instant('err_try_again_later'), null);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/common-main/components/restore-password/restore-password.component.ts